var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform } from 'class-transformer';
export class ModelCommunityUser {
    agreeCookies;
    albumId;
    associationPosition;
    associationPositionName;
    avatar;
    birth;
    bonusStorage;
    businessUnit;
    cdate;
    city;
    city2;
    communityId;
    communityModerator;
    communityRole;
    company;
    contactNumber;
    country;
    country2;
    email;
    fax;
    filesCount;
    firstName;
    gender;
    helpWithContributing;
    id;
    isConfirmed;
    isNewsletter;
    lang;
    lastName;
    mdate;
    memberType;
    memberTypeName;
    mobile;
    msgEventHowStart;
    msgFirstStepHelp;
    msgHowToStart;
    numberHouse;
    numberHouse2;
    placeBirth;
    role;
    state;
    street;
    street2;
    subscriptionYear;
    sumWeight;
    timezone;
    timezone2;
    userStatus;
    zipCode;
    zipCode2;
    fullName;
    firstNameLastName;
}
__decorate([
    Expose({ name: 'agree_cookies' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "agreeCookies", void 0);
__decorate([
    Expose({ name: 'album_id' }),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "albumId", void 0);
__decorate([
    Expose({ name: 'association_position' }),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "associationPosition", void 0);
__decorate([
    Expose({ name: 'association_position_name' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "associationPositionName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "avatar", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "birth", void 0);
__decorate([
    Expose({ name: 'bonus_storage' }),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "bonusStorage", void 0);
__decorate([
    Expose({ name: 'business_unit' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "businessUnit", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "cdate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "city", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "city2", void 0);
__decorate([
    Expose({ name: 'community_id' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "communityId", void 0);
__decorate([
    Expose({ name: 'community_moderator' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "communityModerator", void 0);
__decorate([
    Expose({ name: 'community_role' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "communityRole", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "company", void 0);
__decorate([
    Expose({ name: 'contact_number' }),
    Transform(({ value }) => value?.split('/').map((str) => str.trim())),
    __metadata("design:type", Array)
], ModelCommunityUser.prototype, "contactNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "country", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "country2", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "email", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "fax", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "filesCount", void 0);
__decorate([
    Expose({ name: 'first_name' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "firstName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "gender", void 0);
__decorate([
    Expose({ name: 'help_with_contributing' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "helpWithContributing", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "id", void 0);
__decorate([
    Expose({ name: 'is_confirmed' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "isConfirmed", void 0);
__decorate([
    Expose({ name: 'is_newsletter' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "isNewsletter", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "lang", void 0);
__decorate([
    Expose({ name: 'last_name' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "lastName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "mdate", void 0);
__decorate([
    Expose({ name: 'member_type' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "memberType", void 0);
__decorate([
    Expose({ name: 'member_type_name' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "memberTypeName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "mobile", void 0);
__decorate([
    Expose({ name: 'msg_event_how_start' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "msgEventHowStart", void 0);
__decorate([
    Expose({ name: 'msg_first_step_help' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "msgFirstStepHelp", void 0);
__decorate([
    Expose({ name: 'msg_howtostart' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "msgHowToStart", void 0);
__decorate([
    Expose({ name: 'number_house' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "numberHouse", void 0);
__decorate([
    Expose({ name: 'number_house2' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "numberHouse2", void 0);
__decorate([
    Expose({ name: 'place_birth' }),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "placeBirth", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "role", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "state", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "street", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "street2", void 0);
__decorate([
    Expose({ name: 'subscription_year' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "subscriptionYear", void 0);
__decorate([
    Expose({ name: 'sum_weight' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "sumWeight", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "timezone", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "timezone2", void 0);
__decorate([
    Expose({ name: 'user_status' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "userStatus", void 0);
__decorate([
    Expose({ name: 'zip_code' }),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "zipCode", void 0);
__decorate([
    Expose({ name: 'zip_code2' }),
    __metadata("design:type", Object)
], ModelCommunityUser.prototype, "zipCode2", void 0);
__decorate([
    Expose(),
    Transform(({ obj }) => `${obj.last_name || ''} ${obj.first_name || ''}`.trim()),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "fullName", void 0);
__decorate([
    Expose(),
    Transform(({ obj }) => `${obj.first_name || ''} ${obj.last_name || ''}`.trim()),
    __metadata("design:type", String)
], ModelCommunityUser.prototype, "firstNameLastName", void 0);
